import { twMerge } from 'tailwind-merge';
import type { UnisonProjectTypeId } from '@witmetrics/utils';
import { PROJECT_TYPE_COLORS } from '@witmetrics/unison-core';
import { getProjectTypeLabel } from '@/utils/projects';
import { classes } from './utils';

export type ProjectTypeChipProps = {
  className?: string;
  labelClassName?: string;
  projectTypeId: UnisonProjectTypeId;
};

export default function ProjectTypeChip({
  className,
  projectTypeId,
}: ProjectTypeChipProps) {
  return (
    <span
      className={twMerge(
        classes.label,
        PROJECT_TYPE_COLORS[projectTypeId].bg,
        className
      )}>
      {getProjectTypeLabel(projectTypeId)}
    </span>
  );
}
